<div class="table-responsive">
  <div class="d-flex justify-content-between">
    <!-- Use justify-content-between to align the heading and export link -->
    <h2>{{ location }} - {{ currentQuarter }} Report</h2>
    <div class="d-flex align-items-center">
      <!-- Create a new flex container for Export Excel and the icon -->
      <i class="icon-Export-excel me-2"></i>
      <a class="link" (click)="exportExcelFile()">Export excel</a>
    </div>
  </div>
  <div class="order-dropdown add">
    <p-table
      #dt
      [value]="grid2"
      styleClass="p-datatable-customers ordersLineItems no-wrap poctablecustomscrollbar"
      [rowHover]="true"
      [rows]="10"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10, 25, 50]"
      [paginator]="false"
      [filterDelay]="0"
      scrollHeight="400px"
      [scrollable]="true">
      <ng-template pTemplate="header">
        <tr>
          <th>Support Name</th>
          <th>Title</th>
          <th>Actual Support %</th>
          <th>Notes</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-grid1 let-rowIndex="rowIndex">
        <tr
          class="p-selectable-row mousepointer"
          [ngClass]="{ 'line-gray': !grid1?.isActive }">
          <td class="name mousepointer">{{ grid1?.bc }}</td>
          <td class="name mousepointer">{{ grid1?.title }}</td>
          <td class="name mousepointer">
            {{ grid1?.supportBasedOffNumber | number: "1.2-2" }}%
          </td>
          <td class="name mousepointer">
            {{ grid1?.notes }}
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="20">No data found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-dialog
  [closable]="false"
  [(visible)]="managerNotesModal"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [draggable]="false"
  [resizable]="false">
  <jni-manager-report-notes
    *ngIf="managerNotesModal"
    [bc]="bcPersonnelNumber"
    [manager]="manager"
    [notes]="notes"
    [bcPersonnelNumber]="bcPersonnelNumber"
    [type]="bcReportEnum"
    (cancelEvent)="onCancel()"
    (submitEvent)="onSubmit($event)"></jni-manager-report-notes>
</p-dialog>
